import { render } from "./CustodyHandover.vue?vue&type=template&id=56b15a06&scoped=true"
import script from "./CustodyHandover.vue?vue&type=script&lang=js"
export * from "./CustodyHandover.vue?vue&type=script&lang=js"

import "./CustodyHandover.vue?vue&type=style&index=0&id=56b15a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b15a06"]])

export default __exports__